import { post } from "@/utils/utils";
import moment from "moment";
 
const appointment = {
  state: {
    appointmentListInfo: {
      doneNum: 0,
      outNum: 0,
      totNum: 0,
      orderNum: 0,
      cancelNum: 0,
      pageModel: {
        list: [],
        total: 0,
        pageNo: 0
      }
    },
    dayAppointment: "",
    cancleAppointmentCode: "",
    deleteAppointmentCode: "",
    calendarAppointmentList: [],
    calendarDayAppointment: []
  },
  mutations: {
    CALENDAR_APPOINTMENT_LIST(state, data) {
      state.calendarAppointmentList = data.result;
    },
    CALENDAR_DAY_APPOINTMENT(state, data) {
      state.calendarDayAppointment = data.result;
      state.calendarDayAppointment.forEach(v => {
        v.serverList.forEach(item => {
          item.startDateFormat = moment(item.startDate).format("HH:mm");
          item.endDateFormat = moment(item.endDate).format("HH:mm");
        });
      });
    },
    APPOINTMENT_LIST(state, data) {
      state.appointmentListInfo = data.result;
      state.appointmentListInfo.pageModel.list.forEach(v => {
        v.startDateFormat = moment(v.startDate).format("YYYY-MM-DD HH:mm");
        v.endDateFormat = moment(v.endDate).format("YYYY-MM-DD HH:mm");
        v.createTimeFormat = moment(v.createTime).format("YYYY-MM-DD HH:mm");
        switch (v.status) {
          case 0:
            v.statusFormat = "已预约";
            break;
          case 2:
            v.statusFormat = "已过期";
            break;
          case 3:
            v.statusFormat = "已取消";
            break;
          case 4:
            v.statusFormat = "待审核";
            break;
          case 5:
            v.statusFormat = "已驳回";
            break;
          default:
            break;
        }
      });
    },
    CANCLE_APPOINTMENT(state, data) {
      state.cancleAppointmentCode = data.code;
    },
    DELETE_APPOINTMENT(state, data) {
      state.deleteAppointmentCode = data.code;
    }
  },
  actions: {
    queryCalendarAppointmentList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/index_calendar`,
        name: "CALENDAR_APPOINTMENT_LIST",
        params
      });
    },
    queryCalendarDayAppointment({ commit }, params) {
      return post({
        commit,
        url: `/server-back/day_order_server`,
        name: "CALENDAR_DAY_APPOINTMENT",
        params
      });
    },
    appointmentList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/order_server_list`,
        name: "APPOINTMENT_LIST",
        params
      });
    },
    cancleAppointment({ commit }, params) {
      return post({
        commit,
        url: `/server-back/cancel_server`,
        name: "CANCLE_APPOINTMENT",
        params
      });
    },
    deleteAppointment({ commit }, params) {
      return post({
        commit,
        url: `/server-back/del_server`,
        name: "DELETE_APPOINTMENT",
        params
      });
    }
  }
};

export default appointment;
